import { createSelector } from '@reduxjs/toolkit';

import { offerSelector } from './offer';

export const offerPhonesSelector = createSelector(offerSelector, offer => offer.phones ?? []);
